export const USAGES_SORTING_DEFAULT = 'default'
export const USAGES_SORTING_EXPIRATION_DATE = 'expiration_date'
export const USAGES_SORTING_END_CLIENT = 'end_client'
export const USAGES_SORTING_TITLE = 'title'
